import axios from "axios";

const initialState = { loading: false, error: null };

export const CREATE_DATA_REPORT_REQUEST =
  "data-report/CREATE_DATA_REPORT_REQUEST";
export const CREATE_DATA_REPORT_SUCCESS =
  "data-report/CREATE_DATA_REPORT_SUCCESS";
export const CREATE_DATA_REPORT_FAILURE =
  "data-report/CREATE_DATA_REPORT_FAILURE";

export default function newDataReport(state = initialState, action = {}) {
  switch (action?.type) {
    case CREATE_DATA_REPORT_REQUEST:
      return { ...state, loading: true };
    case CREATE_DATA_REPORT_SUCCESS:
      return { ...state, loading: false, error: null };
    case CREATE_DATA_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const createDataReportRequest = () => ({
  type: CREATE_DATA_REPORT_REQUEST
});

export const createDataReportSuccess = () => ({
  type: CREATE_DATA_REPORT_SUCCESS
});

export const createDataReportFailure = error => ({
  type: CREATE_DATA_REPORT_FAILURE,
  payload: error
});

/**
 * @returns {Promise}
 */
export const createDataReport = () => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();
  dispatch(createDataReportRequest());
  try {
    await axios.post(`${api}/personaluser/dataReports`);
    dispatch(createDataReportSuccess());
    return Promise.resolve();
  } catch (error) {
    dispatch(createDataReportFailure(error));
    return Promise.reject();
  }
};

export const createDataReportLoading = state =>
  state.dataReport.newDataReport.loading || false;
